import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=2fb56a9c"
import script from "./pagination-component.ts?vue&type=script&lang=ts&external"
export * from "./pagination-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports